import { render, staticRenderFns } from "./EditCostCentre.vue?vue&type=template&id=6fae83c6"
import script from "./EditCostCentre.vue?vue&type=script&lang=js"
export * from "./EditCostCentre.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./EditCostCentre.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fae83c6')) {
      api.createRecord('6fae83c6', component.options)
    } else {
      api.reload('6fae83c6', component.options)
    }
    module.hot.accept("./EditCostCentre.vue?vue&type=template&id=6fae83c6", function () {
      api.rerender('6fae83c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/views/EditCostCentre.vue"
export default component.exports